import type { PropsWithChildren } from "react";
import CommonBackground from "#components/design/CommonBackground.tsx";
import SpinningTradeLogo from "#components/design/SpinningTradeLogo.tsx";
import FormError from "#components/errors/FormError.tsx";
import Footer from "#components/layout/Footer.tsx";

export default function AuthForm({
	title,
	before,
	onSubmit,
	formError,
	children,
}: PropsWithChildren<{
	title: string;
	before?: React.ReactNode;
	onSubmit?: React.FormEventHandler<HTMLFormElement>;
	formError?: string | null;
}>) {
	return (
		<CommonBackground className="min-w-screen min-h-screen flex flex-col items-center justify-between">
			<SpinningTradeLogo />

			<section className="bg-box-bg px-6 py-9 m-box rounded-box md:w-xl mb-12">
				{before}
				{formError && <FormError className="mb-4" error={formError} />}
				<h1 className="font-heading tracking-wide text-3xl md:text-title pb-6">
					{title}
				</h1>
				<form onSubmit={onSubmit} className="space-y-3">
					{children}
				</form>
			</section>

			<Footer />
		</CommonBackground>
	);
}
